import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch, RootState } from '@greenkub-fronts/shared/interface';
import { setDocumentIsLoaded } from '@greenkub-fronts/domain/signature';

import PdfBodyLandingPage from '../../ui/web/pdf-body-landing-page/pdf-body-landing-page';

const PdfBodyLandingPageFeature = () => {
  const dispatch = useDispatch<AppDispatch>();

  const sign1Ref = useRef(null);

  const { documentObjectURL, document } = useSelector(
    (state: RootState) => state.signature
  );

  return (
    <PdfBodyLandingPage
      documentObjectURL={documentObjectURL}
      setIsDocumentLoaded={(value: boolean) =>
        dispatch(setDocumentIsLoaded({ documentIsLoaded: value }))
      }
      document={document}
      sign1Ref={sign1Ref}
    />
  );
};

export default PdfBodyLandingPageFeature;
